import {createActionBarButtonAnchor} from '@github-ui/list-view/ListViewActionBar'
import {TriangleDownIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'

import styles from './quick-filter-shared.module.css'

export type QuickFilterProps = {
  owner: string
  query: string
  repo: string
  onQueryChange: (query: string, filter: RepoPullsQuickFilterKind) => void
}

export type RepoPullsQuickFilterKind = 'assignee' | 'author' | 'label' | 'milestone' | 'projects' | 'reviews'

export function createQuickFilterAnchor(label: string) {
  const renderAnchor = createActionBarButtonAnchor({
    children: label,
    trailingVisual: TriangleDownIcon,
    'aria-label': `Filter by ${label.toLowerCase()}`,
  })

  return function QuickFilterAnchor(
    props: Parameters<typeof renderAnchor>[0],
    ref?: Parameters<typeof renderAnchor>[1],
  ) {
    return renderAnchor({...props, className: clsx(styles.quickFilterButton, props.className)}, ref)
  }
}
